/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodLookRight = createReactComponent("mood-look-right", "IconMoodLookRight", [
  ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-0" }],
  ["path", { d: "M15 9h-.01", key: "svg-1" }],
  ["path", { d: "M20 15h-4", key: "svg-2" }]
]);

export { IconMoodLookRight as default };
//# sourceMappingURL=IconMoodLookRight.js.map
